import { graphql } from '../../__generated__';
export const MyClientsSearchUserFragment = graphql(/* GraphQL */ `
  fragment MyClientsSearchResult on RegisteredUser {
    id
    email
    name
    phone
    sender
    type
    senderRegisteredUser {
      id
      name
      phone
    }
  }
`);
